angular.module('filters').filter('cwCurrency', ["$filter", function($filter) {
  return function(amount, symbol) {
    var val;
    if (amount < 0) {
      val = $filter('currency')(amount * -1, symbol);
      return `-${val}`;
    } else {
      return $filter('currency')(amount, symbol);
    }
  };
}]);
